(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-social-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('social-proof-carousel')) {
    customElements.define('social-proof-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = Array.from(this.querySelectorAll('[data-social-proof-item]'));
        if (!this.items.length) return;

        this.items.forEach((item) => this.prepareItem(item));
        this.currentIndex = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
        this.items.forEach((item, index) => this.setItemState(item, index === this.currentIndex));

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMouseEnter = () => this.pause();
        this.onMouseLeave = () => this.play();
        this.onFocusIn = () => this.pause();
        this.onFocusOut = () => this.play();
        this.onVisibilityChange = () => document.hidden ? this.pause() : this.play();

        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.isVisible = entry.isIntersecting;
            entry.isIntersecting ? this.play() : this.pause();
          }, { rootMargin: '50px' });
          this.observer.observe(this);
        } else {
          this.isVisible = true;
        }

        this.play();
      }

      disconnectedCallback() {
        this.pause();
        this.observer?.disconnect();
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.initialized = false;
      }

      prepareItem(item) {
        const base = Number.parseInt(item.dataset.base, 10);
        const variation = Math.max(0, Number.parseInt(item.dataset.variation || '0', 10) || 0);
        const minimum = Math.max(0, Number.parseInt(item.dataset.minimum || '0', 10) || 0);
        let value = base;

        if (variation > 0) {
          value += Math.floor(Math.random() * (variation * 2 + 1)) - variation;
          value = Math.max(minimum, value);
        }

        const threshold = Number.parseInt(item.dataset.bucketThreshold || '0', 10) || 0;
        if (threshold > 0) {
          const lowBucket = Number.parseInt(item.dataset.bucketLow || '0', 10) || 0;
          const highBucket = Number.parseInt(item.dataset.bucketHigh || '0', 10) || 0;
          const bucket = value < threshold ? lowBucket : highBucket;
          if (bucket > 0 && value >= bucket) value = Math.floor(value / bucket) * bucket;
        }
        this.renderTemplate(item, value);
      }

      renderTemplate(item, value) {
        const template = item.dataset.template || '';
        const tokenIndex = template.indexOf('[count]');
        const fragment = document.createDocumentFragment();

        if (tokenIndex < 0) {
          const count = document.createElement('strong');
          count.className = 'product-social-proof__count';
          count.textContent = value;
          fragment.append(count, document.createTextNode(` ${template}`));
        } else {
          fragment.append(document.createTextNode(template.slice(0, tokenIndex)));
          const count = document.createElement('strong');
          count.className = 'product-social-proof__count';
          count.textContent = value;
          fragment.append(count, document.createTextNode(template.slice(tokenIndex + 7)));
        }

        item.replaceChildren(fragment);
      }

      setItemState(item, active) {
        item.classList.toggle('is-active', active);
        item.classList.remove('is-leaving');
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      rotate() {
        const current = this.items[this.currentIndex];
        const nextIndex = (this.currentIndex + 1) % this.items.length;
        const next = this.items[nextIndex];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
        window.setTimeout(() => current.classList.remove('is-leaving'), 520);
        this.currentIndex = nextIndex;
      }

      play() {
        if (this.items.length < 2 || this.timer || document.hidden || this.reducedMotion?.matches || this.isVisible === false) return;
        const interval = Math.max(2000, Number.parseInt(this.dataset.interval, 10) || 4000);
        this.timer = window.setInterval(() => this.rotate(), interval);
      }

      pause() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
